import Vue from 'vue'
import VueRouter from 'vue-router'
import Homepage from '../components/homepage.vue'
import WordsList from '../components/wordsList.vue'
import SynonymList from '../components/synonymList.vue'
import FilterWords from '../components/filterWords.vue'
import Login from '../components/login.vue'
import Login_pc from '../components/login_pc.vue'
import Filter3500 from '../components/filter3500.vue'
import Router from 'vue-router'
import Homepage_pc from '../components/homepage_pc'
import Homepage_pc2 from '../components/homepage_pc2'
import store from '../store/index.js';
import getDate from '../commonApi.js'
import crypto from "crypto"
import jwtDecode from 'jwt-decode'
import { Base64 } from "js-base64";


Vue.use(VueRouter)
Vue.use(Router)

// const router = [
const router = new Router({
  routes: [
    {
      path: '/',
      name: 'homepage',
      component: Homepage,
    },
    {
      path: '/homepage',
      name: 'homepage',
      component: Homepage,
      meta: {
        index: 0
      }
    },
    {
      path: '/homepage_pc2',
      name: 'homepage_pc2',
      component: Homepage_pc2,
      meta: {
        index: 0
      }
    },
    {
      path: '/homepage_pc',
      name: 'homepage_pc',
      component: Homepage_pc,
      meta: {
        index: 0
      }
    },
    {
      path: '/login_pc',
      name: 'login_pc',
      component: Login_pc,
      meta: {
        index: 1
      }
    },
    {
      path: '/filterWords',
      name: 'filterWords',
      component: FilterWords,
      meta: {
        keepalive: true,
        index: 2
      }
    },
    {
      path: '/wordsList',
      name: 'wordsList',
      component: WordsList,
      meta: {
        index: 6
      }
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: {
        index: 3
      }
    },
    {
      path: '/filter3500',
      name: 'filter3500',
      component: Filter3500,
      meta: {
        index: 4
      }
    },
    {
      path: '/synonymList',
      name: 'synonymList',
      component: SynonymList,
      meta: {
        index: 5
      }
    },
  ]
})

// 判断手机还是电脑
function _isMobile() {
  let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
  // console.log(flag)
  return flag;
}

// 解决bug Redirected when going from “/***“ to “/***“ via a navigation guard
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}

// 挂载路由导航守卫
router.beforeEach((to, from, next) => {
  // to 将要访问的路径
  // from 代表从哪个路径跳转而来
  // next 代表放行

  if(to.path == '/' && _isMobile() == null){  // pc登陆直接进入查询页面
    return next('/homepage_pc2')
  }
  if(to.path == '/filter3500'){

    // let curDate = new Date();
    // if (localStorage.getItem('Datewords3500') == null) {
    //   localStorage.setItem("Datewords3500", Base64.encode(curDate));
    // } else {
    //   let tokenDatewords3500 = window.localStorage.getItem('Datewords3500');
    //   let storeDate = new Date(decodeURIComponent(escape(window.atob(tokenDatewords3500))));
    //   storeDate.setDate(storeDate.getDate() + 15);
    //   if (curDate > storeDate) {
    //     console.log('curDate 超过了 storeDate + 15 天');
    //     localStorage.removeItem("words3500");
    //     localStorage.removeItem("newWords");
    //     localStorage.removeItem("Datewords3500");
    //     return next()
    //   } else {
    //     console.log('curDate 未超过 storeDate + 15 天');
    //     return next()
    //   }
    // }

    return next()


    // let tokenStr = window.localStorage.getItem('Authorization3500');


    // if(tokenStr == null){
    //   return next('/login')
    // } 
    // else {


      // let userString = decodeURIComponent(escape(window.atob(tokenStr.split('.')[1])))
      // let tokenData = JSON.parse(userString);



      // console.log('tokenData', tokenData);
      // function getDate(strDate) {
      //   let st = strDate;
      //   let a = st.split(" ");
      //   let b = a[0].split("-");
      //   let c = a[1].split(":");
      //   let date = new Date(b[0], b[1]-1, b[2], c[0], c[1], c[2]);
      //   return date;
      // };
      // let expDate = getDate(tokenData['data'].exp);
      // let curDate = new Date();
      // console.log('expDate', expDate);
      // console.log('curDate', curDate);

      // if(expDate > curDate){
      //   return next()
      // } else {
      //   return next('/login')
      // }
    // }


          
  }
  next()

})
export default router
